import FormMessages from './FormMessages';
import images from '../../../config/local/images';
import React from 'react';

export default class FormGrayMessages extends React.Component {
	render() {
		return (
			<FormMessages
				className={`${this.props.className} form-alert-grey`}
				heading={this.props.heading ?? 'Gray'}
				icon={images.icons.info}
				messages={this.props.messages}
			/>
		);
	}
}
